module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "main-sidebar"
  }, [_c('section', {
    staticClass: "sidebar"
  }, [_c('el-menu', {
    staticClass: "sidebar-menu",
    attrs: {
      "default-active": "2"
    }
  }, [_vm._l((_vm.$config.MODULES), function(menu, index) {
    return _c('el-menu-item', {
      key: menu.id,
      attrs: {
        "index": index
      }
    }, [(!menu.disabled) ? _c('router-link', {
      staticClass: "menu-item",
      attrs: {
        "to": '/' + menu.id
      }
    }, [(menu.icon) ? _c('i', {
      class: menu.icon
    }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(menu.title))])]) : _vm._e()], 1)
  }), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "7"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-comment"
  }), _vm._v(" "), _c('span', {
    staticClass: "submenu_title"
  }, [_vm._v("点评管理")])]), _vm._v(" "), _c('el-menu-item-group', {
    staticClass: "menu_group"
  }, [_c('el-menu-item', {
    attrs: {
      "index": "7-1"
    }
  }, [_c('router-link', {
    staticClass: "menu-item",
    attrs: {
      "to": "/reviews"
    }
  }, [_c('span', [_vm._v("点评中包含的基本信息入库")])])], 1), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "7-2"
    }
  }, [_c('router-link', {
    staticClass: "menu-item",
    attrs: {
      "to": "/reviews/manage"
    }
  }, [_c('span', [_vm._v("点评审核")])])], 1), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "7-3"
    }
  }, [_c('router-link', {
    staticClass: "menu-item",
    attrs: {
      "to": "/reviews/analysis"
    }
  }, [_c('span', [_vm._v("点评智能分析处理")])])], 1)], 1)], 2), _vm._v(" "), _c('el-menu-item', [_c('router-link', {
    staticClass: "menu-item",
    attrs: {
      "to": "/enterprise"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" "), _c('span', [_vm._v("企业账号管理")])])], 1), _vm._v(" "), _c('el-menu-item', [_c('router-link', {
    staticClass: "menu-item",
    attrs: {
      "to": "/proceeds"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  }), _vm._v(" "), _c('span', [_vm._v("收款管理")])])], 1), _vm._v(" "), _c('el-menu-item', [_c('router-link', {
    staticClass: "menu-item",
    attrs: {
      "to": "/meeting"
    }
  }, [_c('i', {
    staticClass: "fa fa-commenting"
  }), _vm._v(" "), _c('span', [_vm._v("会议频道管理")])])], 1), _vm._v(" "), _c('el-menu-item', [_c('router-link', {
    staticClass: "menu-item",
    attrs: {
      "to": "/sales"
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v(" "), _c('span', [_vm._v("销售线索管理")])])], 1), _vm._v(" "), _c('el-menu-item', [_c('router-link', {
    staticClass: "menu-item",
    attrs: {
      "to": "/company"
    }
  }, [_c('i', {
    staticClass: "fa fa-database"
  }), _vm._v(" "), _c('span', [_vm._v("厂商管理")])])], 1), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "10"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-th-large"
  }), _vm._v(" "), _c('span', {
    staticClass: "submenu_title"
  }, [_vm._v(" 类别管理")])]), _vm._v(" "), _c('el-menu-item-group', {
    staticClass: "menu_group"
  }, [_c('el-menu-item', {
    attrs: {
      "index": "10-1"
    }
  }, [_c('router-link', {
    staticClass: "menu-item",
    attrs: {
      "to": "/category"
    }
  }, [_c('span', [_vm._v("类别列表")])])], 1), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "10-2"
    }
  }, [_c('router-link', {
    staticClass: "menu-item",
    attrs: {
      "to": "/funcList/new/:id"
    }
  }, [_c('span', [_vm._v("功能清单")])])], 1)], 1)], 2), _vm._v(" "), _c('el-menu-item', [_c('router-link', {
    staticClass: "menu-item",
    attrs: {
      "to": "/product"
    }
  }, [_c('i', {
    staticClass: "fa fa-inbox"
  }), _vm._v(" "), _c('span', [_vm._v("产品管理")])])], 1), _vm._v(" "), _c('el-menu-item', [_c('router-link', {
    staticClass: "menu-item",
    attrs: {
      "to": "/analysis"
    }
  }, [_c('i', {
    staticClass: "fa fa-line-chart"
  }), _vm._v(" "), _c('span', [_vm._v("智能分析管理")])])], 1), _vm._v(" "), _c('el-menu-item', [_c('router-link', {
    staticClass: "menu-item",
    attrs: {
      "to": "/news"
    }
  }, [_c('i', {
    staticClass: "fa fa-newspaper-o"
  }), _vm._v(" "), _c('span', [_vm._v("新闻管理")])])], 1), _vm._v(" "), _c('el-menu-item', [_c('router-link', {
    staticClass: "menu-item",
    attrs: {
      "to": "/document"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o"
  }), _vm._v(" "), _c('span', [_vm._v("文档管理")])])], 1), _vm._v(" "), _c('el-menu-item', [_c('router-link', {
    staticClass: "menu-item",
    attrs: {
      "to": "/person"
    }
  }, [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" "), _c('span', [_vm._v("转型100人")])])], 1), _vm._v(" "), _c('el-menu-item', [_c('router-link', {
    staticClass: "menu-item",
    attrs: {
      "to": "/industry"
    }
  }, [_c('i', {
    staticClass: "fa fa-tags"
  }), _vm._v(" "), _c('span', [_vm._v("行业及标签配置")])])], 1)], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-53019214!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/Sidebar.vue
// module id = 459
// module chunks = 11